import {
  Typography as MuiTypography,
  DialogContent as MuiDialogContent,
  Box as MuiBox,
  useTheme,
} from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';
import styled from 'styled-components';
import DialogTitle from 'components/Dialogs/DialogTitle';
import QuestionnaireDialogItem from './QuestionnaireDialogItem';

import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import { getMainComponent } from 'lib/utils/metricComponents';

const QuestionnaireDetailsDialog = (props) => {
  const { close, back, initialValues } = props;
  const { t } = useTranslation();
  const theme = useTheme()
  const { responses, questionnaire, metricDefinitionId } = initialValues;


  return (
    <>
      <DialogTitle
        titleButton={
          back && (
            <SMuiBox
              onClick={back}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <BackIcon fontSize="10" />
              <MuiTypography fontSize={14} align="center" margin="1rem 0.5rem">
                {t('Back')}
              </MuiTypography>
            </SMuiBox>
          )
        }
        onClose={close}
      />

      <MuiDialogContent>
        <MuiTypography variant="h1" align="left">
          {`${t('Score')}: `}
          {responses?.status !== 'COMPLETED'
            ? t('Not completed yet')
            : responses?.mainScoreMetric?.metricDefinitionId ===
              metricDefinitionId
            ? getMainComponent(responses?.mainScoreMetric?.components)?.quantityValue
                ?.value || '-'
            : getMainComponent(
                responses?.subScoreMetrics?.find(
                  (subscore) =>
                    subscore?.metricDefinitionId === metricDefinitionId
                )?.components
              )?.quantityValue?.value || '-'}
        </MuiTypography>
        <MuiBox display={'flex'} mt={1} alignItems="center">
          <MuiTypography
            fontSize={14}
            fontWeight={500}
            mr={0.5}
            width="150px"
            color={theme.palette.colors.gray400}
          >
            {`${t('Formula')}: `}
          </MuiTypography>
          <MuiTypography fontSize={14} fontWeight={500}>
            {questionnaire?.mainScoreMetricDefinitionId === metricDefinitionId
              ? questionnaire?.mainScoreConfig?.formula?.expression
                  ?.replaceAll('__RAW_VALUE', ` (${t('Raw value')})`)
                  ?.replaceAll('__SCORE', ` (${t('Score')})`) ?? '-'
              : questionnaire.subScoreConfig
                  ?.find(
                    (subscore) =>
                      subscore?.metricDefinitionId === metricDefinitionId
                  )
                  ?.formula?.expression?.replaceAll(
                    '__RAW_VALUE',
                    ` (${t('Raw value')})`
                  )
                  ?.replaceAll('__SCORE', ` (${t('Score')})`) ?? '-'}
          </MuiTypography>
        </MuiBox>
        <MuiBox display={'flex'} mt={1} alignItems="center">
          <MuiTypography
            fontSize={14}
            fontWeight={500}
            mr={0.5}
            width="150px"
            color={theme.palette.colors.gray400}
          >
            {t('Terminology')}:
          </MuiTypography>
          <MuiTypography fontSize={14} fontWeight={500}>
            {questionnaire?.mainScoreConfig?.code?.coding?.[0]?.display || '-'}
          </MuiTypography>
        </MuiBox>
        <MuiBox display={'flex'} mt={1} alignItems="center">
          <MuiTypography
            fontSize={14}
            fontWeight={500}
            mr={0.5}
            width="150px"
            color={theme.palette.colors.gray400}
          >
            {t('Date')}:
          </MuiTypography>
          <MuiTypography fontSize={14} fontWeight={500}>
            {responses?.status !== 'COMPLETED'
              ? t('Not completed yet')
              : responses?.mainScoreMetric?.metricDefinitionId ===
                metricDefinitionId
              ? t(
                  format(
                    parseISO(responses?.mainScoreMetric?.createdAt),
                    'MMMM'
                  )
                ).slice(0, 3) +
                  format(
                    parseISO(responses?.mainScoreMetric?.createdAt),
                    ' dd, YYY'
                  ) || ''
              : t(
                  format(
                    parseISO(
                      responses?.subScoreMetrics?.find(
                        (subscore) =>
                          subscore?.metricDefinitionId === metricDefinitionId
                      )?.createdAt
                    ),
                    'MMMM'
                  )
                ).slice(0, 3) +
                  format(
                    parseISO(
                      responses?.subScoreMetrics?.find(
                        (subscore) =>
                          subscore?.metricDefinitionId === metricDefinitionId
                      )?.createdAt
                    ),
                    ' dd, YYY'
                  ) || ''}
          </MuiTypography>
        </MuiBox>

        <MuiBox marginTop={4}>
          {responses?.questionStates.map((item, i) => (
            <QuestionnaireDialogItem
              key={item.questionId}
              state={item}
              response={responses?.questionResponses?.find(
                (q) => q.questionId === item.questionId
              )}
              question={questionnaire?.questions?.find(
                (q) => q.id === item.questionId
              )}
              index={i}
            />
          ))}
        </MuiBox>
      </MuiDialogContent>
    </>
  );
};

export default QuestionnaireDetailsDialog;

const SMuiBox = styled(MuiBox)`
  && {
    cursor: pointer;
  }
`;
